@if(isAuth) {
    <app-core></app-core>
}
@else {
    <app-loader [loading]="!isAuth">
        <p-skeleton height="var(--header-height)"></p-skeleton>
        <div class="flex items-end">
            <p-skeleton 
                class="mt-1"
                width="var(--menu-primary-not-expanded-width)"
                height="calc(100vh - var(--header-height) - var(--spacing))">
            </p-skeleton>
            <p-skeleton 
                class="ml-1"
                width="calc(100vw - var(--menu-primary-not-expanded-width) - var(--spacing))"
                height="var(--footer-height)">
            </p-skeleton>
        </div>
    </app-loader>
}